export const CATEGORY_PLUGILO_VIDEO = "plugilo-video";
export const CATEGORY_MERKEN_BUTTON = "merken_button";
export const CATEGORY_USER_ACTIVATION = "user_activation";
export const CATEGORY_USER_REGISTRATION = "user_registration";
